import { Map } from "immutable"

export const listRequest = type => ({
    limit,
    offset,
    nextOffset,
    searchCriteria,
    ...rest
} = {}) => ({
    type,
    limit: limit || 20,
    offset: offset || 0,
    nextOffset: nextOffset || 0,
    searchCriteria: Map.isMap(searchCriteria)
        ? searchCriteria
        : Map(searchCriteria),
    ...rest
})

export const listInvalidationRequest = type => pagingRequest => ({
    type,
    ...pagingRequest,
    isInvalidating: true,
    nextOffset: 0,
    offset: 0
})

export const listResponse = type => (
    data,
    limit,
    offset,
    searchCriteria,
    isInvalidating,
    callbackActionCreator
) => ({
    type,
    data,
    limit,
    offset,
    nextOffset: limit + offset,
    isInvalidating,
    searchCriteria,
    receivedAt: Date.now(),
    callbackActionCreator
})

export const listCachedResponse = type => (
    data,
    limit,
    offset,
    searchCriteria,
    callbackActionCreator
) => ({
    data,
    type,
    limit,
    offset,
    nextOffset: offset,
    searchCriteria,
    callbackActionCreator
})

export const listErrorResponse = type => (
    error,
    searchCriteria,
    callbackActionCreator
) => ({
    type,
    error,
    searchCriteria,
    callbackActionCreator
})
